module.exports = __webpack_public_path__ + "img/SamsungGalaxyA72017.79015f3f.png";